import {
  AppBar,
  IconButton,
  Toolbar,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import HeaderContent from "./HeaderContent";
import AppBarStyled from "./AppBarStyled";
import IMenuDrawerProps from "@/interfaces/Props/IMenuDrawerProps";
import MenuUnfoldOutlined from "@/assets/icon/MenuUnfoldOutlined";
import MenuFoldOutlined from "@/assets/icon/MenuFoldOutlined";

const Header = ({ open, handleDrawerToggle, window }: IMenuDrawerProps) => {
  const theme = useTheme();
  const matchDownMD = useMediaQuery(theme.breakpoints.down("lg"));

  const mainHeader = (
    <Toolbar>
      <IconButton
        disableRipple
        aria-label="open drawer"
        onClick={handleDrawerToggle}
        edge="start"
        sx={{ bgcolor: "secondary.background.paper", ml: { xs: 0, lg: -2 } }}
      >
        {!open ? (
          <MenuUnfoldOutlined fontSize="medium" color="action" />
        ) : (
          <MenuFoldOutlined fontSize="medium" color="action" />
        )}
      </IconButton>
      <HeaderContent />
    </Toolbar>
  );

  // app-bar params
  const appBar = {
    elevation: 0,
    sx: {
      borderBottom: `1px solid ${theme.palette.divider}`,
    },
  };

  return (
    <>
      {!matchDownMD ? (
        <AppBarStyled theme={theme} open={open} enableColorOnDark {...appBar}>
          {mainHeader}
        </AppBarStyled>
      ) : (
        <AppBar {...appBar} enableColorOnDark>
          {mainHeader}
        </AppBar>
      )}
    </>
  );
};

export default Header;
